import script from "./EntityInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./EntityInfo.vue?vue&type=script&lang=ts&setup=true"

import "./EntityInfo.vue?vue&type=style&index=0&id=26f00f90&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f00f90"]])

export default __exports__